import { render, staticRenderFns } from "./Chaos.vue?vue&type=template&id=487e2fe8&scoped=true&"
import script from "./Chaos.vue?vue&type=script&lang=js&"
export * from "./Chaos.vue?vue&type=script&lang=js&"
import style0 from "./Chaos.vue?vue&type=style&index=0&id=487e2fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e2fe8",
  null
  
)

export default component.exports